import axios from 'axios'
//axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
//axios.defaults.withCredentials = false
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// 请求拦截器
service.interceptors.request.use(
  config => {
  console.log(config)
  return config // 必须要返回的
}, error => {
  return Promise.reject(error)
}
)
// 响应拦截器
service.interceptors.response.use(response => {
  // axios默认加了一层data
  // console.log(response.data)
  if (response.request.responseType === 'blob') {
    return response
  }
  const { handleResult, errMessage} = response.data
  //   要根据success的成功与否决定下面的操作
  if (handleResult == 0) {
    return response.data
  } else if(handleResult == 1){
    return response.data
  }else{
    return Promise.reject(new Error(errMessage))//返回执行错误，让当前执行连跳出成功，直接进入catch
  }
}, error => {
  return Promise.reject(error)//返回执行错误，让当前执行连跳出成功，直接进入catch
})


 export default service

